import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
} from "chart.js"
import { Line } from "react-chartjs-2"

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend)

// A small palette for up to 8 different symbol lines
const COLORS = [
    "#00e5ff", "#00ff88", "#ff6b35", "#a855f7",
    "#facc15", "#f43f5e", "#38bdf8", "#4ade80"
]

// FIX (Bug 7): Original chart used array index [0,1,2,3...] as labels and
// plotted ALL spread data as one flat line with no time context.
// Now:
//   - X axis shows real timestamps (created_at from DB, or sequence numbers
//     if timestamps are unavailable)
//   - When data contains multiple symbols, each gets its own colored line
//   - When a single symbol is selected, one clean line is shown

function ChartPanel({ data }) {
    if (!data || data.length === 0) {
        return <p style={{ color: "#888" }}>No data to display yet.</p>
    }

    // Group data points by symbol
    const bySymbol = {}
    data.forEach((d, i) => {
        const sym = d.symbol || "unknown"
        if (!bySymbol[sym]) bySymbol[sym] = []
        bySymbol[sym].push({
            x: d.created_at ? new Date(d.created_at).toLocaleTimeString() : `#${i + 1}`,
            y: parseFloat(d.spread_percent) || 0
        })
    })

    const symbols = Object.keys(bySymbol)

    // Build a unified label axis from all timestamps
    const allLabels = data.map((d, i) =>
        d.created_at ? new Date(d.created_at).toLocaleTimeString() : `#${i + 1}`
    )
    // Deduplicate while preserving order
    const labels = [...new Set(allLabels)]

    const datasets = symbols.slice(0, 8).map((sym, idx) => {
        // Map this symbol's points onto the shared label axis
        const pointMap = {}
        bySymbol[sym].forEach(p => { pointMap[p.x] = p.y })

        return {
            label: sym,
            data: labels.map(l => pointMap[l] ?? null),
            borderColor: COLORS[idx % COLORS.length],
            backgroundColor: COLORS[idx % COLORS.length] + "22",
            fill: symbols.length === 1,  // fill only when single symbol shown
            tension: 0.3,
            pointRadius: 2,
            spanGaps: true,
        }
    })

    const chartData = { labels, datasets }

    const options = {
        responsive: true,
        plugins: {
            legend: { position: "top" },
            title: {
                display: true,
                text: "Spread % over time"
            },
            tooltip: {
                callbacks: {
                    label: ctx => `${ctx.dataset.label}: ${ctx.parsed.y?.toFixed(3)}%`
                }
            }
        },
        scales: {
            y: {
                title: { display: true, text: "Spread %" },
                ticks: { callback: v => v.toFixed(2) + "%" }
            },
            x: {
                title: { display: true, text: "Time" },
                ticks: { maxTicksLimit: 10 }
            }
        }
    }

    return <Line data={chartData} options={options} />
}

export default ChartPanel
